import { Routes, RouterModule } from "@angular/router";

import { StudentComponent } from "./components/student.component";
import { DisciplineComponent } from "./discipline/discipline.component";
import { MTAHistoryComponent } from "./mtahistory/mtahistory.component";
import { GuardianNotificationComponent } from "./guardiannotification/guardiannotification.component";
import { AttendanceComponent } from "./attendance/attendance.component";
import { StudentMeritComponent } from "./student-merit/student-merit.component";
import { StudentAlertsComponent } from "./student-alerts/student-alerts.component";
import { StudentClassAttendanceComponent } from "./student-class-attendance/student-class-attendance.component";
import { StudentScanHistoryComponent } from "./student-scan-history/student-scan-history.component";
import { StudentDemographicsComponent } from "./student-demographics/student-demographics.component";
import { StudentScheduleComponent } from "./student-schedule/student-schedule.component";
import { StudentReleaseComponent } from "./student-release/student-release.component";
import { StudentFinesDebtsComponent } from "./student-fines-debts/student-fines-debts.component";
import { StudentLockersComponent } from "./student-lockers/student-lockers.component";
import { StudentGuidanceComponent } from "./student-guidance/student-guidance.component";
import { StudentPBISComponent } from "./student-pbis/student-pbis.component";
import { StudentMealsComponent } from "./student-meals/student-meals.component";
import { StudentDigitalIdRegistrationComponent } from "./student-digital-id-registration/student-digital-id-registration.component";
import { StudentHallSweepComponent } from "./student-hall-sweep/student-hall-sweep.component";
import { AuthguardService } from "../master/services";

export const StudentRoutes: Routes = [
	{ path: "", redirectTo: "/student/demographics", pathMatch: "full" },
	{
		path: "demographics",
		data: { title: "Demographics" },
		component: StudentDemographicsComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "incident",
		data: { title: "Discipline" },
		component: DisciplineComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "attendance",
		data: { title: "Attendance" },
		component: AttendanceComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "schedule",
		data: { title: "Schedule" },
		component: StudentScheduleComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "classattendance",
		data: { title: "Student Class Attendance" },
		component: StudentClassAttendanceComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "release",
		data: { title: "Release", HideSelector: true },
		component: StudentReleaseComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "guidance",
		data: { title: "Guidance" },
		component: StudentGuidanceComponent,
		canActivate: [AuthguardService],
	}, //New
	{
		path: "fines",
		data: { title: "Fines/Debts" },
		component: StudentFinesDebtsComponent,
		canActivate: [AuthguardService],
	}, //New Version
	{
		path: "locker",
		data: { title: "Locker Assignment" },
		component: StudentLockersComponent,
		canActivate: [AuthguardService],
	}, //New
	{
		path: "merit",
		data: { title: "Merits/Demerits" },
		component: StudentMeritComponent,
		canActivate: [AuthguardService],
	}, //Merits (Can be turned on and off in application maintenance)
	{
		path: "pbis",
		data: { title: "PBIS", HideSelector: true },
		component: StudentPBISComponent,
		canActivate: [AuthguardService],
	}, //PBIS (On be default. Can be turned on and off in application maintenance)
	{
		path: "scan",
		data: { title: "Student Scan History" },
		component: StudentScanHistoryComponent,
		canActivate: [AuthguardService],
	}, //New
	{
		path: "notifyguard",
		data: { title: "Guardian Notifications" },
		component: GuardianNotificationComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "alertmanagement",
		data: { title: "Student With Alerts", HideSelector: true },
		component: StudentAlertsComponent,
		canActivate: [AuthguardService],
	}, //Old
	{
		path: "mtahistory",
		data: { title: "MTA Ride History" },
		component: MTAHistoryComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "meal",
		data: { title: "Meals/Debts" },
		component: StudentMealsComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "didregistration",
		data: { title: "Digital ID Registration", HideSelector: true },
		component: StudentDigitalIdRegistrationComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "hallsweep",
		data: { title: "CAASS Pass" },
		component: StudentHallSweepComponent,
		canActivate: [AuthguardService],
	},
];
